<template>
  <section>
  <el-table
    :data="tableData"
    class="el-table-info"
    stripe
    style="margin-left: 5%;width: 90%;"
  >
    <el-table-column
      :formatter="publicFmt"
      prop="shipName"
      label="船舶名称"
      width="100">
    </el-table-column>
    <el-table-column
      :formatter="publicFmt"
      prop="voyageNumber"
      label="航次号"
      width="120">
    </el-table-column>
      <el-table-column
        :formatter="companyFmt"
        prop="receiveTo"
        label="开票对象"
        width="120">
      </el-table-column>
    <el-table-column
      :formatter="NumFmt"
      prop="ticketPrice1"
      label="卖票价格"
      width="100">
    </el-table-column>
    <el-table-column
      :formatter="NumFmt"
      prop="totalUnpaid"
      label="开票金额"
      >
    </el-table-column>
  </el-table>
  </section>
</template>

<script>
    import dayjs from "dayjs";
    import {ERR_OK} from "../../jslib/config";
    import {getCompanyReceiveList} from "../../api/shiplinetranspay";
    import {getDictionaryList} from "../../api/sysdictionary";
    import {fmtDictionary} from "../../jslib/util";

    export default {
          name: "CompanyTicketApprove",
        props: {
          datas: {
            type: Object
          },
          applyObj:{
            type: Object
          },
        },
      data(){
        return{
          tableData:[],
          dictionaryLists:[],
        }
      },
        mounted() {
          this.getData()
          getDictionaryList("contract_company,dian_company").then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.dictionaryLists = res.map
            }
          })
        },
        methods: {
          getData(){
            this.tableData = []
            if(this.applyObj){
              var querydata = {
                shipLineId:this.applyObj.shipLineId,
              }
              getCompanyReceiveList(querydata).then(res =>{
                if (res!=undefined&&res.resultCode === ERR_OK) {
                  this.tableData = res.list
                }
              })
            } else {
              var querydata = {
                shipLineId:this.datas.params1,
              }
              getCompanyReceiveList(querydata).then(res =>{
                if (res!=undefined&&res.resultCode === ERR_OK) {
                  this.tableData = res.list
                }
              })
            }
          },
          myFmtDateTime(cellValue,fmtstr){
            if(cellValue==undefined||cellValue==null||cellValue==''){
              return '--'
            }
            return dayjs(cellValue).format(fmtstr)
          },
          publicFmt(row,column,cellValue,index){
            var v = '--'
            if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
              v = cellValue
            }
            return v
          },
          NumFmt(row,column,cellValue,index){
            var v = 0
            if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
              v = parseFloat(Math.abs(cellValue).toFixed(2)) && parseFloat(Math.abs(cellValue).toFixed(2)).toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
            }
            return v
          },
          number_format(num) {
            var v = 0
            if(!!num){
              v = parseFloat(Math.abs(num).toFixed(2)) && parseFloat(Math.abs(num).toFixed(2)).toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
            }
            return v
          },
          companyFmt(row,column,cellValue,index){
            var v= null
            if(row.isSellTicket == 1){
              v= fmtDictionary(cellValue,this.dictionaryLists['dian_company']);
            } else {
              v= fmtDictionary(cellValue,this.dictionaryLists['contract_company']);
            }
            return v
          },
        }
    }
</script>

<style scoped>

  .query-form{
    text-align: left;
    padding-top: 10px;
  }
  .el-table-info >>> .cell{
    text-align: center;
  }
  .el-table-info >>> th {
    background: #EDF5FF;
  }
</style>
